import React from 'react';

export function useQueryParamState(field: string): [string | null, React.Dispatch<React.SetStateAction<string | null>>] {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const value = urlParams.get(field);

	if (value) {
		const url = new URL(window.location.href);
		url.searchParams.delete(field);
		window.history.replaceState({}, document.title, url.toString());
	}

	return React.useState<string | null>(value);
}
